// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
:host {
    --gw-size-0: 0px;
    --gw-size-025: 1px;
    --gw-size-050: 2px;
    --gw-size-075: 3px;
    --gw-size-100: 4px;
    --gw-size-150: 6px;
    --gw-size-200: 8px;
    --gw-size-250: 10px;
    --gw-size-275: 11px;
    --gw-size-300: 12px;
    --gw-size-325: 13px;
    --gw-size-350: 14px;
    --gw-size-400: 16px;
    --gw-size-450: 18px;
    --gw-size-500: 20px;
    --gw-size-550: 22px;
    --gw-size-600: 24px;
    --gw-size-750: 30px;
    --gw-size-800: 32px;
    --gw-size-900: 36px;
    --gw-size-1000: 40px;
    --gw-size-1200: 48px;
    --gw-size-1600: 64px;
    --gw-size-2000: 80px;
    --gw-size-2400: 96px;
    --gw-size-3200: 128px;
    --gw-size-full: 9999px;
}
`, "",{"version":3,"sources":["webpack://./src/themes/default_v2/size.css"],"names":[],"mappings":"AAAA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;AAC1B","sourcesContent":[":root,\n:host {\n    --gw-size-0: 0px;\n    --gw-size-025: 1px;\n    --gw-size-050: 2px;\n    --gw-size-075: 3px;\n    --gw-size-100: 4px;\n    --gw-size-150: 6px;\n    --gw-size-200: 8px;\n    --gw-size-250: 10px;\n    --gw-size-275: 11px;\n    --gw-size-300: 12px;\n    --gw-size-325: 13px;\n    --gw-size-350: 14px;\n    --gw-size-400: 16px;\n    --gw-size-450: 18px;\n    --gw-size-500: 20px;\n    --gw-size-550: 22px;\n    --gw-size-600: 24px;\n    --gw-size-750: 30px;\n    --gw-size-800: 32px;\n    --gw-size-900: 36px;\n    --gw-size-1000: 40px;\n    --gw-size-1200: 48px;\n    --gw-size-1600: 64px;\n    --gw-size-2000: 80px;\n    --gw-size-2400: 96px;\n    --gw-size-3200: 128px;\n    --gw-size-full: 9999px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
